import React, { useEffect, useState } from "react";
import { useDispatch } from "react-redux";
import BreadcrumbsComponent from "../../Components/BreadCrumbs";
import LeftSideNav from "../../Components/LeftSideNav";
import Loader from "../../Components/Loader";
import TopNavBar from "../../Components/TopNavbar";
import { getpageDetailsAPI } from "../../Store/Action/page";
import PageTable from "./Component/PageTable";

const Page = () => {
  const dispatch = useDispatch();

  const [breadcrumbs, setBreadcrumbs] = useState([]);
  const [page, setpage] = useState([]);
  const [loading, setLoading] = useState(false);
  useEffect(() => {
    setBreadcrumbs([
      { key: "1", href: "/", text: "Home" },
      { key: "2", href: "/userList", text: "Masters" },
      { key: "3", href: "/page", text: "page" },
    ]);
  }, []);

  useEffect(() => {
    dispatch(
      getpageDetailsAPI({}, (result) => {
     
        setpage(result);
      })
    );
  }, []);
 

  return (
    <div
      style={{
        display: "grid",
        gridTemplateColumns: "20% 80%",
        height: "100vh",
        width: "100vw",
        overflowX: "hidden",
        overflowY: "hidden",
      }}
    >
      <LeftSideNav />

      <div
        style={{
          backgroundColor: "#F0F5FF",
          display: "flex",
          flexDirection: "column",
          height: "100%",
          paddingRight: "20px",
        }}
      >
        <TopNavBar />

        <div
          style={{
            marginLeft: "30px",
            justifyContent: "flex-start",
            display: "flex",
          }}
        >
          <h2>Page</h2>
        </div>

        <BreadcrumbsComponent breadcrumbs={breadcrumbs} />

        <PageTable page={page} />
      </div>

      <Loader loading={loading} />
    </div>
  );
};

export default Page;
